import * as React from 'react';
import {
    ICustomerPortalService,
    Policy,
    Types, CLAIM_TYPE_OTHER
} from "@falcon/services";
import {setSessionStorage,} from "../../../../../CommonFunctions";
import {lazyInject} from "@athena-portal/core";
import {Overlay} from "@athena-portal/components";
import {ButtonLink} from "../../../../../components/navigation/ButtonLink";
import {Types as JourneyCoreTypeDefs, ILookupService} from "@athena-portal/plugin-journey";
import * as moment from "moment";
import {HomePolicySummary} from "./HomePolicySummary";
import {PluginTemplates} from "../../../../../utils/PluginTemplates";
import {NavigateFunction} from "react-router-dom";

export interface IProps{
    policy: Policy;
    policyNumber: string;
    navigate: NavigateFunction;
}

export class HomePolicySummaryPanel extends React.Component<IProps, {}> {
    protected pluginTemplates = new PluginTemplates();

    @lazyInject(Types.CustomerPortalService)
    protected customerPortalService: ICustomerPortalService;

    @lazyInject(JourneyCoreTypeDefs.LookupService)
    protected lookupService: ILookupService;

    public componentDidMount(): void {
        this.pluginTemplates.setPageTitle("Policy summary");
    }

    public render(): React.ReactNode {
        const claimsLink = this.props.policy.interaction?.annualHomeFixedAddons?.homeEmergency
            ? `/dashboard/annualHome/${this.props.policy.policyNumber}/claims/new`
            : `/dashboard/annualHome/${this.props.policy.policyNumber}/claims/details`;
        if (!this.props.policy.interaction?.annualHomeFixedAddons?.homeEmergency) {
            setSessionStorage("claim", CLAIM_TYPE_OTHER);
        }

        if (!this.props.policy) {
            return <Overlay show={true}/>
        } else {
            const policy: Policy = this.props.policy;
            const policyStarted = policy && moment(policy.endDate).isAfter(moment(policy.startDate));
            return (
                <React.Fragment>
                {this.renderPolicyNumber()}
                    <div className="section-panel your-cover-panel padding-top-bot-50">
                        <HomePolicySummary
                            policy={policy}
                            editAddress={false}
                            isOldPolicy={true}
                            hasDebt={false}
                        />
                    </div>
                    {policyStarted && <ButtonLink
                        primaryNoArrow={true}
                        className="make-a-claim"
                        to={claimsLink}>
                        Make a claim
                    </ButtonLink>}
                </React.Fragment>
            )
        }
    }

    public renderPolicyNumber(): React.ReactNode {
        return (
            <div className="page-heading-white">
                <span className="font-weight-light">Policy no: </span>
                {this.props.policy.policyNumber}
            </div>
        );
    }

}
